module.exports = __webpack_public_path__ + "static/media/garcia_turner_pinholster_sweeney_durig.aa51c094.png";